
import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import { Task, TaskStatus } from "@/models/tasks/task";
import Vue from "vue";
import AppChatWrapper from "@/components/chat-components/ChatWrapper.vue";
import { ISelectItem } from "winfakt-vue-components";
import { TasksState } from "../../utils/tasks-state";
import { FolderUser } from "../../models/tasks/folder-user";
import { TaskService } from "../../services/task-service";

export default Vue.extend({
	props: {
		state: {
			type: Object as () => TasksState,
			required: true
		}
	},
	computed: {
		value():Task{
			return this.state.openedTask as Task;
		},
		title():string {
			return this.value.Text;
		},
		backUrl():string {
			return `/tasks/${this.value.FolderID}`;
		},
		selectItems():ISelectItem<string>[]{
			let items = [
			] as ISelectItem<string>[];

			if (this.taskFolder && this.taskFolder.IsOwner){
				items.push({
					text: this.$ct("edit-task").toString(),
					value: "editTask",
					icon: "pen"
				});
				if (this.value.Status != TaskStatus.COMPLETED){
					items.push({
						text: this.$ct("mark-as-done").toString(),
						value: "markAsDone",
						icon: "check"
					});
				}
			}else if (this.value.Status == TaskStatus.PENDING){
				items.push({
					text: this.$ct("mark-as-done").toString(),
					value: "markAsUnconfirmed",
					icon: "check"
				});
			}


			return items;
		},
		taskFolder():FolderUser{
			return this.state.openedFolder as FolderUser;
		}
	},
	methods: {
		onFiles(files:File[]){
			for (let file of files){
				this.$emit("file",file);
			}
		},
		editTask(){
			this.$emit("edit");
		},
		async markAsDone(){
			if (!this.state.openedTask) return;
			await TaskService.setTaskStatus(this.state.openedTask, TaskStatus.COMPLETED);
			this.state.openedTask.Status = TaskStatus.COMPLETED;
		},
		async markAsUnconfirmed(){
			if (!this.state.openedTask) return;
			await TaskService.setTaskStatus(this.state.openedTask as Task, TaskStatus.UNCONFIRMED);
			this.state.openedTask.Status = TaskStatus.UNCONFIRMED;
		},
		trigger(val:string){
			if (val == "editTask"){
				this.editTask();
			} else if (val == "markAsDone"){
				this.markAsDone();
			} else if (val == "markAsUnconfirmed"){
				this.markAsUnconfirmed();
			}
		}
	},
	components: {
		AppMobileFullScreenContainer,
		AppToolbar,
		AppChatWrapper,
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
